import { v4 } from 'uuid';

export const getUniqueId = (): string => v4();
